export default {
    nameFirst: {
        "ui:autocomplete": "disabled"
    },
    nameMiddle: {
        "ui:autocomplete": "disabled"
    },
    nameLast: {
        "ui:autocomplete": "disabled"
    },
    emailPrimary: {
        "ui:autocomplete": "disabled"
    },
    emailAlternate: {
        "ui:autocomplete": "disabled"
    },
    dateOfDeath: {
        "ui:widget": "hidden"
    },
    isUSCitizen: {
        "ui:widget": "radio"
    },
    isDisabled: {
        "ui:widget": "radio"
    },
    isMedicareEligible: {
        "ui:widget": "radio"
    },
    isCurrentSmoker: {
        "ui:widget": "radio"
    },
    isPreviousSmoker: {
        "ui:widget": "radio"
    },
    heightInInches: {
        "ui:widget": "hidden"
    },
    weightInPounds: {
        "ui:widget": "hidden"
    },
    hasOtherMedicalCoverage: {
        "ui:widget": "radio"
    },
    phonePrimary: {
        "ui:emptyValue": "",
        "ui:widget": "formatPhone"
    },
    phoneAlternate: {
        "ui:emptyValue": "",
        "ui:widget": "formatPhone"
    },
    usSocialSecurityNumber: {
        "ui:widget": "formatSSN"
    },
    dateOfBirth: {
        "ui:widget": "customDate"
    },
    otherCoverageEffectiveDate: {
        "ui:widget": "customDate"
    },
    previousSmokerQuitDate: {
        "ui:widget": "customDate"
    }
} as const;